<div class="message-input-bar">
  <button (click)="messagesRefreshed.emit('Refresh')" [disabled]="isLoading()" aria-label="Refresh" id="messages-refresh">
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
      <path d="M0 0h24v24H0z" fill="none"/>
      <path class="icon"
        d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
        fill="#808080"/>
      </svg>
    </button>
    <div class="input">
      <input id="message-input" aria-label="Message text" maxlength="2000" placeholder="{{hint()}}"
        [(ngModel)]="messageValue"
        (ngModelChange)="updateSendEnabled()"
        [disabled]="isLoading()"
        />
      </div>
      <div class="add-attachment" [appDropdownTriggerFor]="dropdownComponent">
        <button [attr.aria-label]="'Add attachments with ' + numberOfAttachments() + ' attachments selected'" [disabled]="isLoading()">
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
            <path d="M0 0h24v24H0z" fill="none"/>
            <path class="icon" [class.highlight]="numberOfAttachments() > 0"
              d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"/>
            </svg>
            @if (numberOfAttachments() > 0) {
              <span class="number-of-attachments">{{numberOfAttachments()}}</span>
            }
          </button>
          <app-dropdown #dropdownComponent [ignoreClass]="'attachment__remove'" [arrowOffset]="1" [arrowBackgroundColour]="'arrow-grey'">
            <app-message-attachment-menu
              [attachmentsList]="attachments()"
              (addFiles)="addFiles($event)"
              (removeAttachment)="removeAttachment($event)"
            ></app-message-attachment-menu>
          </app-dropdown>
        </div>
        <button class="send-button" [disabled]="isLoading() || !messageCanBeSent()" [class.enabled]="!isLoading() && messageCanBeSent()" (click)="messageSend()" aria-label="Send message">
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
            <path d="M0 0h24v24H0z" fill="none"/>
            <path class="icon" d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
          </svg>
        </button>
      </div>
